import InventoryRecords from "../../manager/purchases/inventory";

// Supply Management > Reagents: the branch inventory, reagents only
export const Reagents = () => <InventoryRecords scope="reagents" />;

// Supply Management > Supplies: everything that is not a reagent
export const Supplies = () => <InventoryRecords scope="supplies" />;
